export function appendSlashIfRequired(value: string) {
  if (value.startsWith("/")) {
    value = value.substring(1)
  }

  if (value == "") return value

  return value.endsWith("/") ? value : value + "/"
}